import { formatHHMM } from '../../lib/format';
import { useMapStore } from '../../state/mapStore';

export function StatusLine({ error }: { error: string | null }) {
  const updated = useMapStore((s) => s.dataUpdatedAt);
  const notice = useMapStore((s) => s.notice);
  const text = error ?? notice ?? (updated ? `Data updated ${formatHHMM(updated)}` : '');
  return (
    <div className="mm-status" role="status" aria-live="polite">
      {text}
    </div>
  );
}
